import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { diaDePrueba, etapaPorDia } from '../utils/seguimientoPrueba';
import { EN_TIENDA } from '../utils/tienda';

// Mensaje del día dentro de Kontrol durante la prueba gratis (días 1-3, 7-9 y
// 12-14). Solo para la dueña. Se puede cerrar y no vuelve a salir en esa etapa.
const leer = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const guardar = (k) => { try { localStorage.setItem(k, '1'); } catch { /* sin almacenamiento */ } };

export default function MensajePrueba({ onIr }) {
  const { negocio, suscripcion } = useAuth();
  const dia = suscripcion?.estado === 'prueba' && suscripcion?.prueba_hasta ? diaDePrueba(suscripcion.prueba_hasta) : null;
  const etapa = dia ? etapaPorDia(dia) : null;
  const clave = `kontrol-prueba-${negocio?.id}-${etapa}`;
  const [cerrado, setCerrado] = useState(() => !!leer(clave));
  if (negocio?.rol !== 'duena' || !etapa || cerrado || suscripcion?.eliminacion_solicitada_en) return null;

  const cerrar = () => { guardar(clave); setCerrado(true); };
  const quedan = Math.max(0, 15 - dia);
  const boton = (texto, vista) => (
    <button onClick={() => onIr(vista)} className="k-btn-soft" style={{ background: '#fff' }}>{texto}</button>
  );

  let titulo; let texto; let botones;
  if (etapa === 1) {
    titulo = '👋 ¡Te damos la bienvenida a Kontrol! Empieza en 3 pasos';
    texto = <ol style={{ margin: '6px 0 0', paddingLeft: '20px', lineHeight: 1.6 }}>
      <li>Agrega 3 o 4 de tus productos o servicios más vendidos.</li>
      <li>Haz tu primera venta desde <b>Vender</b>.</li>
      <li>Comparte tu <b>catálogo en línea</b> con tus clientes.</li>
    </ol>;
    botones = <>{boton('📦 Ir a Inventario', 'inventario')}{boton('🛒 Vender', 'pos')}</>;
  } else if (etapa === 7) {
    titulo = '💡 Vas a la mitad de tu prueba. ¿Ya probaste esto?';
    texto = <ul style={{ margin: '6px 0 0', paddingLeft: '20px', lineHeight: 1.6 }}>
      <li><b>Reportes:</b> qué productos te dejan más ganancia.</li>
      <li><b>Corte del día:</b> cuadra tu caja en un minuto.</li>
      <li><b>Mi equipo:</b> invita a quien te ayuda a vender, con los permisos que tú decidas.</li>
    </ul>;
    botones = <>{boton('📊 Reportes', 'reportes')}{boton('☀️ Corte del día', 'corte')}</>;
  } else {
    titulo = `⏳ Tu prueba gratis termina en ${quedan} ${quedan === 1 ? 'día' : 'días'}`;
    texto = <p style={{ margin: '6px 0 0' }}>
      {EN_TIENDA
        ? 'Cuando termine, tu cuenta queda en pausa, pero tu información no se borra.'
        : 'Elige tu plan para seguir trabajando sin pausas. Si no lo haces, tu cuenta queda en pausa, pero tu información no se borra.'}
    </p>;
    botones = EN_TIENDA ? null : boton('💎 Ver planes', 'planes');
  }

  return (
    <div style={{ background: '#F5F3FF', border: '1px solid #C4B5FD', color: '#1C1830', borderRadius: '14px', padding: '14px 16px', marginBottom: '16px', position: 'relative' }}>
      <button onClick={cerrar} aria-label="Cerrar este mensaje"
        style={{ position: 'absolute', top: '8px', right: '10px', background: 'none', border: 'none', fontSize: '18px', color: '#6B7280', cursor: 'pointer' }}>×</button>
      <b style={{ fontSize: '15px', paddingRight: '24px', display: 'block' }}>{titulo}</b>
      <div style={{ fontSize: '14px', color: '#374151' }}>{texto}</div>
      {botones && <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '10px' }}>{botones}</div>}
    </div>
  );
}
